// 家长角色userType：2
const parent = () => import('@/views/parent/index');
const parent_home = () => import('@/views/parent/home/index');
const parent_home_parentQues = () => import('@/views/parent/home/parentQues');
const parent_home_parentMessage = () => import('@/views/parent/home/parentMessage.vue');

const parent_main_index = () => import('@/views/parent/main/index');
const parent_main_main= () => import('@/views/parent/main/main');
const parent_main_studentMessage= () => import('@/views/parent/main/studentMessage/index');
const parent_main_studentMessage_grade= () => import('@/views/parent/main/studentMessage/grade/index');
const parent_main_studentMessage_grade_list= () => import('@/views/parent/main/studentMessage/grade/list');
const parent_main_studentMessage_grade_detail = () => import('@/views/parent/main/studentMessage/grade/detail');

const parent_main_studentMessage_competition= () => import('@/views/parent/main/studentMessage/competition/index');
const parent_main_studentMessage_competition_list= () => import('@/views/parent/main/studentMessage/competition/list');
const parent_main_studentMessage_competition_detail = () => import('@/views/parent/main/studentMessage/competition/detail');

const parent_main_studentMessage_quality= () => import('@/views/parent/main/studentMessage/quality/index');
const parent_main_studentMessage_quality_list= () => import('@/views/parent/main/studentMessage/quality/list');
const parent_main_studentMessage_quality_detail = () => import('@/views/parent/main/studentMessage/quality/detail');

const parent_main_studentMessage_studentQues= () => import('@/views/parent/main/studentMessage/studentQues/studentMessage.vue');
const parent_main_studentMessage_parentQues = () => import('@/views/parent/main/studentMessage/parentQues/parentMessage.vue');

//规划内容调整
const parent_main_planningContent= () => import('@/views/parent/main/planningContent/index');
const parent_main_planningContent_recordList= () => import('@/views/parent/main/planningContent/recordList');
const parent_main_planningContent_planningReport = () => import('@/views/parent/main/planningContent/planningReport.vue');
const parent_main_planningContent_adjustmentReport= () => import('@/views/parent/main/planningContent/adjustmentReport.vue');

//
const parent_main_consultationRecord= () => import('@/views/parent/main/consultationRecord/index');
const parent_main_consultationRecord_student= () => import('@/views/parent/main/consultationRecord/student/index');
const parent_main_consultationRecord_student_studentRecord=() => import('@/views/parent/main/consultationRecord/student/list.vue');
const parent_main_consultationRecord_student_detail= () => import('@/views/parent/main/consultationRecord/student/detail.vue');

const parent_main_consultationRecord_parent= () => import('@/views/parent/main/consultationRecord/parent/index');
const parent_main_consultationRecord_parent_parentRecord=() => import('@/views/parent/main/consultationRecord/parent/list.vue');
const parent_main_consultationRecord_parent_detail= () => import('@/views/parent/main/consultationRecord/parent/detail.vue');

const parent_main_studentMessage_report= () => import('@/views/parent/main/studentMessage/report/report');
const parent_main_studentMessage_part_A= () => import('@/views/parent/main/studentMessage/report/firstInterviewPartA');
const parent_main_studentMessage_reportInterpretation=() => import('@/views/parent/main/studentMessage/report/reportInterpretation');
const parent_main_studentMessage_reportInterpretation2=() => import('@/views/parent/main/studentMessage/report/reportInterpretation2');
// 家长学习力报告
const parent_main_studentMessage_reportLearning=() => import('@/views/parent/main/studentMessage/reportLearning/learningReport2');
// 学习力报告解读
const parent_main_studentMessage_report_unscramble=() => import('@/views/parent/main/studentMessage/reportLearning/learningReportunscramble');
// 家长学习力报告3
const parent_main_studentMessage_reportLearning3=() => import('@/views/parent/main/studentMessage/reportLearning/learningReport3');
const parent_main_studentMessage_report_unscramble3=() => import('@/views/parent/main/studentMessage/reportLearning/learningReportunscramble3');






// 我的学生-数据分析
const parent_main_dataAnalysis= () => import('@/views/parent/main/dataAnalysis/index');
const parent_main_dataAnalysis_actionPlan= () => import('@/views/parent/main/dataAnalysis/actionPlan');
const parent_main_dataAnalysis_grade= () => import('@/views/parent/main/dataAnalysis/grade');

//我的学生-计划执行
const parent_main_implement= () => import('@/views/parent/main/implement/index');
const parent_main_implement_targetSplit= () => import('@/views/parent/main/implement/targetSplit');
const parent_main_implement_actionPlan= () => import('@/views/parent/main/implement/actionPlan');
const parent_main_implement_assessment= () => import('@/views/parent/main/implement/assessment');

//我的学生-计划执行-阶段评估
const parent_main_implement_assessment_list= () => import('@/views/parent/main/implement/assessment/list');
const parent_main_implement_assessment_show= () => import('@/views/parent/main/implement/assessment/show');

//我的学生-计划执行-目标拆分
const parent_main_implement_targetSplit_list= () => import('@/views/parent/main/implement/targetSplit/list');
const parent_main_implement_targetSplit_show= () => import('@/views/parent/main/implement/targetSplit/show');

//我的学生-计划执行-行动计划
const parent_main_implement_actionPlan_list= () => import('@/views/parent/main/implement/actionPlan/list');
const parent_main_implement_actionPlan_show= () => import('@/views/parent/main/implement/actionPlan/show');
const parent_main_implement_actionPlan_gradeDetail= () => import('@/views/parent/main/implement/actionPlan/gradeDetail');
const parent_main_implement_actionPlan_gradeDetailassessment= () => import('@/views/parent/main/implement/actionPlan/gradeDetailassessment');
const parent_main_implement_actionPlan_assessmentShow= () => import('@/views/parent/main/implement/actionPlan/assessmentShow');


// 成长档案
//我的学生-成长档案
const parent_main_growthFile_index= () => import('@/views/parent/main/growthFile/index');
const parent_main_growthFile_entry=() => import('@/views/parent/main/growthFile/entry.vue');
const parent_main_growthFile_report = () => import('@/views/consultant/student/mine/main/growthFile/report.vue');
export default
{
    path:'/parent',
    name:'家长学业规划主页',
    redirect:'/parent/home',
    component: parent,
    children:[
        {
            path: '/parent/home',
            component: parent_home,
            redirect:'/parent/home/ques',
            children:[
                {
                    path:'/parent/home/ques',
                    name:'家长问卷',
                    component:parent_home_parentQues,
                    meta:{requireAuth:true,roles:['parent']},
                },
                {
                    path:'/parent/home/quesMessage',
                    name:'家长问卷展示',
                    component:parent_home_parentMessage,
                    meta:{requireAuth:true,roles:['parent']}
                },
            ]
        },
        {
            path: '/parent/main',
            component: parent_main_index,
            redirect: '/parent/main/main',
            children:[
                {
                    path: "/parent/main/main",
                    component: parent_main_main,
                    meta:{requireAuth:true,roles:['parent']}
                },
                {
                    path: "/parent/main/studentMessage",
                    component: parent_main_studentMessage,
                    redirect: '/parent/main/studentMessage/grade',
                    children: [
                        {
                            path: '/parent/main/studentMessage/grade',
                            component: parent_main_studentMessage_grade,
                            redirect: '/parent/main/studentMessage/grade/list',
                            children: [
                                {
                                    path: '/parent/main/studentMessage/grade/list',
                                    component: parent_main_studentMessage_grade_list,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/studentMessage/grade/detail',
                                    component: parent_main_studentMessage_grade_detail,
                                    meta:{requireAuth:true,roles:['parent']}
                                }]
                        },
                        {
                            path: '/parent/main/studentMessage/competition',
                            component: parent_main_studentMessage_competition,
                            redirect: '/parent/main/studentMessage/competition/list',
                            children: [
                                {
                                    path: '/parent/main/studentMessage/competition/list',
                                    component: parent_main_studentMessage_competition_list,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/studentMessage/competition/detail',
                                    component: parent_main_studentMessage_competition_detail,
                                    meta:{requireAuth:true,roles:['parent']}
                                }
                            ]
                        },
                        {
                            path: '/parent/main/studentMessage/quality',
                            component: parent_main_studentMessage_quality,
                            redirect: '/parent/main/studentMessage/quality/list',
                            children: [
                                {
                                    path: '/parent/main/studentMessage/quality/list',
                                    component: parent_main_studentMessage_quality_list,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/studentMessage/quality/detail',
                                    component: parent_main_studentMessage_quality_detail,
                                    meta:{requireAuth:true,roles:['parent']}
                                }
                            ]
                        },
                        {
                            path: '/parent/main/studentMessage/student',
                            component: parent_main_studentMessage_studentQues,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/studentMessage/parent',
                            component: parent_main_studentMessage_parentQues,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/studentMessage/report',
                            component: parent_main_studentMessage_report,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        

                        {
                            path: '/parent/main/studentMessage/reportInterpretation',
                            component: parent_main_studentMessage_reportInterpretation,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/studentMessage/reportInterpretation2',
                            component: parent_main_studentMessage_reportInterpretation2,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        // 学习力测评报告
                        {
                            path: '/parent/main/studentMessage/reportLearning/learningReport2',
                            component: parent_main_studentMessage_reportLearning,
                            meta:{requireAuth:true,roles:['parent']},
                        },
                        //学习力测评报告解读
                        {
                            path: '/parent/main/studentMessage/reportLearning/learningReportunscramble',
                            component: parent_main_studentMessage_report_unscramble,
                            meta:{requireAuth:true,roles:['parent']},
                        },
                        // 学习力测评报告3
                        {
                            path: '/parent/main/studentMessage/reportLearning/learningReport3',
                            component: parent_main_studentMessage_reportLearning3,
                            meta:{requireAuth:true,roles:['parent']},
                        },
                        //学习力测评报告解读3
                        {
                            path: '/parent/main/studentMessage/reportLearning/learningReportunscramble3',
                            component: parent_main_studentMessage_report_unscramble3,
                            meta:{requireAuth:true,roles:['parent']},
                        },

                    ]
                },
                {
                    path: "/parent/main/planningContent",
                    component: parent_main_planningContent,
                    redirect: '/parent/main/planningContent/recordList',
                    children: [
                        {
                            path: '/parent/main/studentMessage/part_A',
                            component: parent_main_studentMessage_part_A,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/planningContent/recordList',
                            component: parent_main_planningContent_recordList,
                            meta:{requireAuth:true,roles:['parent']}
                        },

                        {
                            path: '/parent/main/planningContent/planningReport',
                            component: parent_main_planningContent_planningReport,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/planningContent/adjustmentReport',
                            component: parent_main_planningContent_adjustmentReport,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                    ]
                },
                {
                    path:"/parent/main/consultationRecord",
                    component: parent_main_consultationRecord,
                    redirect:'/parent/main/consultationRecord/student',
                    children:[
                        {
                            path: '/parent/main/consultationRecord/student',
                            component: parent_main_consultationRecord_student,
                            redirect:'/parent/main/consultationRecord/student/studentRecord',
                            children:[
                                {
                                    path: '/parent/main/consultationRecord/student/studentRecord',
                                    component: parent_main_consultationRecord_student_studentRecord,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/consultationRecord/student/detail',
                                    component: parent_main_consultationRecord_student_detail,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                            ]
                        },
                        {

                            path: '/parent/main/consultationRecord/parent',
                            component: parent_main_consultationRecord_parent,
                            redirect:'/parent/main/consultationRecord/parent/parentRecord',
                            children:[
                                {
                                    path: '/parent/main/consultationRecord/parent/parentRecord',
                                    component: parent_main_consultationRecord_parent_parentRecord,
                                    meta:{requireAuth:true,roles:['parent']}

                                },
                                {
                                    path: '/parent/main/consultationRecord/parent/detail',
                                    component: parent_main_consultationRecord_parent_detail,
                                    meta:{requireAuth:true,roles:['parent']}
                                },

                            ]
                        },
                    ]
                },

                {
                    path: '/parent/main/dataAnalysis',
                    component: parent_main_dataAnalysis,
                    children: [
                        {
                            path: '/parent/main/dataAnalysis/grade',
                            component: parent_main_dataAnalysis_grade,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/dataAnalysis/actionplan',
                            component: parent_main_dataAnalysis_actionPlan,
                            meta:{requireAuth:true,roles:['parent']}
                        }
                    ]
                },
                {
                    path: '/parent/main/implement',
                    component: parent_main_implement,
                    children: [
                        {
                            path: '/parent/main/implement/targetsplit',
                            component: parent_main_implement_targetSplit,
                            redirect: '/parent/main/implement/targetsplit/list',
                            children: [
                                {
                                    path: '/parent/main/implement/targetsplit/list',
                                    component: parent_main_implement_targetSplit_list,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/implement/targetsplit/show',
                                    component: parent_main_implement_targetSplit_show,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                            ]
                        },
                        {
                            path: '/parent/main/implement/actionplan',
                            component: parent_main_implement_actionPlan,
                            redirect: '/parent/main/implement/actionplan/list',
                            children: [
                                {
                                    path: '/parent/main/implement/actionplan/list',
                                    component: parent_main_implement_actionPlan_list,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/implement/actionplan/show',
                                    component: parent_main_implement_actionPlan_show,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/implement/actionplan/gradeDetail',
                                    component: parent_main_implement_actionPlan_gradeDetail,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/implement/actionplan/gradeDetailassessment',
                                    component: parent_main_implement_actionPlan_gradeDetailassessment,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/implement/actionplan/assessmentShow',
                                    component: parent_main_implement_actionPlan_assessmentShow,
                                    meta:{requireAuth:true,roles:['parent']}
                                }
                                ]
                        },
                        {
                            path: '/parent/main/implement/assessment',
                            component: parent_main_implement_assessment,
                            redirect: '/parent/main/implement/assessment/list',
                            children: [
                                {
                                    path: '/parent/main/implement/assessment/list',
                                    component: parent_main_implement_assessment_list,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                                {
                                    path: '/parent/main/implement/assessment/show',
                                    component: parent_main_implement_assessment_show,
                                    meta:{requireAuth:true,roles:['parent']}
                                },
                            ]
                        },
                    ]
                },
                {
                    path:"/parent/main/growthFile",
                    component: parent_main_growthFile_index,
                    redirect:'/parent/main/growthFile/entry',
                    children:[
                        {
                            path: '/parent/main/growthFile/entry',
                            component: parent_main_growthFile_entry,
                            meta:{requireAuth:true,roles:['parent']}
                        },
                        {
                            path: '/parent/main/growthFile/report',
                            component: parent_main_growthFile_report,
                            meta:{requireAuth:true,roles:['parent']}
                        }
                    ]
                },
            ]
        },

    ]
}
